// import React from 'react';
// import ReactDOM from 'react-dom';
// import Template from './pages/Home2';
// ReactDOM.render(
//     <>
//        <Template/>
//     </>,
//   document.getElementById('root')
// );

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// import Template from "./pages/Home2";
import App from "./App"

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
